import axios_nomura from './axios-nomura.services';

export const fetchMonthlyReport = async (payload) => {
  let accountNumber = payload.accountNumber.length > 0 ? payload.accountNumber.toString() : null;
  delete payload.accountNumber;
  return await axios_nomura.post(`api/v1/accounts/${accountNumber}/monthly_report`, JSON.stringify(payload));
};

export const fetchMonthlyReportChart = async (payload) => {
  return await axios_nomura.post(`/api/v1/accounts/${payload.accountNumber}/monthly_report/chart`, null, { params: { date: payload.date} });
};

// Monthly Report For Investment(Portfolio).
export const fetchMonthlyReportChartForPortFolios = async (payload) => {
  return await axios_nomura.post(`/api/v1/portfolios/groups/chart`, payload );
};
